// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__WV5xo","large":"styles_large__18V--"};